import styled from "styled-components";
import UiButton from "../../../../../../components/Button";
import UiModal from "../../../../../../components/Modal";

export const Modal = styled(UiModal)``;

export const ModalDialog = styled("div")``;

export const Title = styled.div`
  margin: 24px 0px 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
`;

export const Text = styled.div`
      margin-bottom: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

export const Button = styled(UiButton)`
  min-width: 175px;
`;

